export default "__VITE_ASSET__B2W7gjOG__"